export const PASTA_CHOICE = [
  {
    id: 1,
    name: 'Spaghetti',
    pastaSmall: 4.99,
    pastaLarge: 0.00
  },
  {
    id: 2,
    name: 'Penne',
    pastaSmall: 4.99,
    pastaLarge: 0.00
  },
];